export const Formatter = {
    isMacAddress: (value) => {
        const macAddressRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
        return macAddressRegex.test(value);
    },

    isIpAddress: (value) => {
        const ipV4Regex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
        const ipV6Regex = /([0-9a-fA-F]{1,4}:){7}([0-9a-fA-F]{1,4})/;  // Basic regex for IPv6

        return ipV4Regex.test(value) || ipV6Regex.test(value);
    },

    isEmpty: (value) => {
      return value === "" || value === null || value === undefined
    },

    errorViewModelToKeyValPair:  (input) => {
        return Object.entries(input).map(([key, value]) => ({ key, value }));
    }
};
